import React from 'react';

export function GreenLine() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 992 628"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M18.7593 46.8308C211.495 124.434 244.203 451.516 293.594 460.271C431.556 472.895 410.099 -105.862 731.388 115.513C1035.56 335.712 922.914 584.351 804.647 577.825C675.105 554.337 682.151 337.138 851.005 227.125C925.506 178.586 923.38 179.728 968.307 155.591"
        stroke="#81D0B0"
        strokeWidth="100"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export function OrangeLine() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 731 691"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M702.3 102.963C575.422 189.191 380.102 25.5126 353.751 53.9331C286.695 140.038 616.448 454.282 354.004 545.759C99.6636 626.331 11.0574 408.936 66.1629 332.682C135.568 258.44 252.745 386.58 240.133 563.234C234.568 641.175 234.862 639.089 228.663 683.175"
        stroke="#FF874B"
        strokeWidth="100"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export function YellowLine() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1191 1013"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M391.233 2.27353C366.248 -3.19855 331.703 6.18065 304.826 25.7331C259.741 58.5322 208.409 120.826 146.483 217.89C114.064 268.707 54.1907 374.402 26.1876 430.248L0.77185 480.934L25.5891 492.53C39.2402 498.911 57.1548 506.996 65.4008 510.497L80.3946 516.863L115.38 449.065C181.972 320.027 260.037 197.172 313.276 137.627C329.54 119.438 358.059 95.3791 361.277 97.1329C364.162 98.7047 359.737 126.932 352.875 150.753C344.04 181.422 329.217 218.465 292.802 300.89C216.304 474.04 201.183 525.492 211.402 577.865C216.838 605.724 236.591 628.008 263.051 636.134C304.814 648.962 349.329 628.6 404.044 571.642C415.341 559.881 443.366 528.242 466.325 501.336C529.144 427.709 558.763 399.871 587.229 387.704C609.698 378.103 631.519 384.837 644.362 405.34C660.18 430.592 653.323 462.723 608.586 572.995C568.242 672.448 559.065 706.511 560.63 751.015C562.065 791.724 580.557 825.05 613.368 846.055C654.78 872.563 701.126 873.329 743.606 848.21C765.518 835.249 787.221 815.17 826.898 771.143C875.88 716.787 890.347 707.92 911.263 719.436C934.707 732.344 934.151 752.21 908.309 825.284C884.451 892.746 880.266 915.393 886.11 945.354C887.826 954.154 893.255 967.609 898.169 975.252C906.052 987.507 909.647 990.525 928.573 1000.79C947.024 1010.79 952.361 1012.47 966.584 1012.77C999.471 1013.46 1027.06 999.829 1065.46 963.915C1090 940.969 1107.38 928.285 1115.79 927.182C1119.68 926.669 1127.59 927.837 1133.38 929.776L1143.9 933.297L1167 890.919L1190.09 848.541L1182.73 844.586C1169.51 837.483 1141.16 831.161 1125.24 831.767C1106.13 832.492 1074.03 843.4 1056.65 855.07C1049.54 859.844 1032.16 874.382 1018.02 887.379C966.181 935.024 963.797 931.079 993.543 846.853C1017.26 779.716 1022.36 746.417 1014.57 709.789C999.779 640.216 922.679 600.312 858.067 628.786C838.132 637.572 807.688 661.611 785.051 686.439C718.057 759.924 705.514 770.862 687.793 771.255C673.121 771.582 655.64 759.834 652.221 747.347C646.088 724.953 653.82 694.716 685.615 616.773C732.181 502.621 742.156 467.364 741.413 419.559C740.438 356.925 701.015 305.676 642.725 291.266C617.842 285.113 598.329 286.748 568.225 297.512C524.304 313.213 483.675 346.645 422.675 417.278C354.884 495.772 333.28 519.316 317.991 531.344C309.128 538.32 300.941 542.951 299.794 541.635C296.304 537.625 304.829 502.615 317.91 467.243C324.728 448.809 346.652 396.452 366.627 350.897C423.499 221.202 439.868 177.112 448.486 130.411C456.006 89.6725 451.38 55.2057 435.342 32.4694C427.053 20.7168 404.291 5.13518 391.233 2.27353Z"
        fill="#FFE365"
      />
    </svg>
  );
}
